export * from "./ApplicationRouter";



// WEBPACK FOOTER //
// ./src/router/index.ts